import { PARTICIPANT_INFO_ACTION, STORE_LIST_ACTION } from 'core/constants/Actions'
import { TypedThunk, TypedDispatch } from 'App/Store'
import { getParticipantInfo } from 'core/services/TournamnetBracket'

export function getParticipantInfoList(tournamentId: string): TypedThunk {
  return async (dispatch: TypedDispatch) => {
    dispatch({ type: PARTICIPANT_INFO_ACTION.REQUEST })
    const apiResponse = await getParticipantInfo(tournamentId)
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: PARTICIPANT_INFO_ACTION.SUCCESS,
        payload: { tournamentTeams: apiResponse.data.tournamentTeams, count: apiResponse.data.count, currentPage:0 }
      })
    } else {
      dispatch({
        type: PARTICIPANT_INFO_ACTION.FAILURE
      })
    }
  }
}